import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Error403() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16 text-center sm:px-6 lg:px-8 animate-in fade-in duration-500">
      <Helmet>
        <title>Adgang nægtet (403) | Bachmann Tømrer</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="max-w-md">
        {/* Decorative Icon */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-50 text-red-600 mb-8 border border-red-100">
          <i className="fa-solid fa-lock text-4xl" />
        </div>

        <span className="text-xs font-bold uppercase tracking-widest text-red-600">Fejl 403</span>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-brand-graphite mt-2 mb-4">
          Adgang nægtet
        </h1>
        <p className="text-xs sm:text-sm text-brand-graphite/70 mb-8 leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os eller gå tilbage til forsiden.
        </p>

        {/* Navigation Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto rounded-full bg-brand-brown px-6 py-3 text-xs font-bold uppercase tracking-wider text-white shadow-md transition-all duration-300 hover:bg-brand-brown-dark hover:shadow-lg"
          >
            <i className="fa-solid fa-house mr-1.5" /> Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto rounded-full border border-brand-brown/30 bg-white px-6 py-3 text-xs font-bold uppercase tracking-wider text-brand-brown hover:bg-brand-beige"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
